var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',{attrs:{"href":_vm.href,"download":""}},[_vm._t("default")],2):_c('span',{staticClass:"is-disabled"},[_vm._t("default"),_vm._v(" "),_c('a-label',{attrs:{"path":"download.link.notActive"}}),_vm._v(" "),_c('a-label',{attrs:{"path":"download.notSelected"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }